/**
 * Utility functions for date and time formatting
 */

/**
 * Converts a UTC timestamp to America/Bogota timezone and formats it for display
 * @param {string|Date} utcTimestamp - ISO 8601 timestamp string or Date object
 * @returns {string} Formatted date string in America/Bogota timezone
 */
export const formatToBogotaTime = (utcTimestamp) => {
  if (!utcTimestamp) return '';

  const date = new Date(utcTimestamp);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }

  // Convert to America/Bogota timezone (UTC-5)
  // Use Intl.DateTimeFormat for proper timezone conversion
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  }).format(date);
};

/**
 * Converts a UTC timestamp to America/Bogota timezone with Spanish locale
 * @param {string|Date} utcTimestamp - ISO 8601 timestamp string or Date object
 * @returns {string} Formatted date string in America/Bogota timezone with Spanish formatting
 */
export const formatToBogotaTimeES = (utcTimestamp) => {
  if (!utcTimestamp) return '';

  const date = new Date(utcTimestamp);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'Fecha inválida';
  }

  // Convert to America/Bogota timezone with Spanish locale
  return new Intl.DateTimeFormat('es-CO', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  }).format(date);
};
